export default function parseEvent(event) {
  const [touch] = event.touches || event.changedTouches || []
  if (touch) {
    return { x: touch.pageX, y: touch.pageY }
  }
  return { x: event.clientX, y: event.clientY }
}
